<template>
    <div v-if="levelType" class="text-primary font-weight-bold">
        <div class="mb-2">
            <span class="mr-1"><img :src="levelTypeImage" class="level-type-icon" /> </span>
            <span class="text__mc-type">
                {{
                    levelType === 'CAREER_SPECIFIC'
                        ? 'Career Specific'
                        : 'Academic Focused'
                }}
            </span>
        </div>
        <div class="wrapper__progress-bar">
            <div class="progress mt-2 progress-container">
                <div class="progress-bar bg-primary" role="progressbar" :style="{ width: `${progressPercentage}%` }"
                    :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <span class="text__learning-progress">{{ progressPercentage }}%</span>
        </div>
    </div>
</template>

<script>
import specificImage from '@/assets/learning-unit-types/specific.svg';
import academicImage from '@/assets/learning-unit-types/academic.svg';

export default {
    name: 'LearningUnitProgress',

    props: {
        levelType: {
            type: String,
            required: true
        },
        methodComponents: {
            type: Array,
            required: true,
            default: () => []
        },
        readComponentIds: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        levelTypeImage() {
            return this.levelType === 'CAREER_SPECIFIC' ? specificImage : academicImage;
        },

        progressPercentage() {
            if (!this.methodComponents?.length) return 0;

            const totalComponents = this.methodComponents.length;
            const completedComponents = this.readComponentIds.length;

            return Math.round((completedComponents / totalComponents) * 100);
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper__progress-bar {
    display: flex;
    justify-content: space-between;
}

.progress {
    border-radius: 4px;
    background-color: #e9ecef;

    &-bar {
        border-radius: 4px;
        transition: width 0.6s ease;
    }
}

.text__mc-type {
    font-weight: 500;
}

.text__learning-progress {
    font-size: 16px;
    font-weight: 400;
    color: #3b3e66;
}

.progress-container {
    height: 8px;
    width: 80%;
}

.level-type-icon {
    height: 16px;
}
</style>